export const INSPECTION_CAPTURE = 'inspectionCapture';
export const INSPECTION_CREATE = 'inspectionCreate';
export const INSPECTION_VEHICLE_UPDATE = 'InspectionVehicleUpdate';
export const INSPECTION_LIST = 'inspectionList';
export const INSPECTION_PROMPT = 'inspectionPrompt';
export const INSPECTION_FEEDBACK = 'inspectionFeedback';
export const INSPECTION_REPORT = 'inspectionReport';
export const LANDING = 'landing';
export const SIGN_IN = 'signIn';
